import React from "react";
import Utils from "Utils/utils";
import PreviewEditorTemplate from "Components/common/PreviewEditorTemplate";
import { observer } from "mobx-react";

import { writingAssistantStoreData } from "Stores/WritingAssistantData";

const PreviewSequenceTemplate = observer(props => {
  const {
    contentBody = "",
    attachments = [],
    subject = "",
    currentStage = 1,
    replyAsThread = false,
    hasTitle = false,
    fromAddress = null,
    inboxIds = [],
    autoAppendSignature = true
  } = props || {};

  const effectiveInboxIds = fromAddress?.id ? [fromAddress.id] : inboxIds;

  const previewDom = Utils.getContentWithSignature(
    contentBody,
    effectiveInboxIds,
    fromAddress?.email || "",
    autoAppendSignature
  );

  return (
    <div className="previewContentWrap">
      <PreviewEditorTemplate
        subject={replyAsThread ? "Re: [Previous email subject line]" : subject}
        contentBody={Utils.contentReadyOnly(previewDom?.outerHTML)}
        attachments={attachments || []}
        currentStage={currentStage}
        inboxIds={effectiveInboxIds}
        titleText="Preview Sequence"
        hasTitle={hasTitle}
        sampleParsedSpintax={writingAssistantStoreData?.sampleParsedSpintax}
        sampleParsedSubject={writingAssistantStoreData?.sampleParsedSubject}
      />
    </div>
  );
});

export default PreviewSequenceTemplate;
export { PreviewSequenceTemplate };
